import { authClient, configureAccessTokenRefresh } from '@/api/client'
import { useUserStore } from '@/store'
import type { CurrentUser } from '@/store'

const AUTH_PATH = '/api/v1/auth'

export interface LoginInput {
  usernameOrEmail: string
  password: string
}

export interface AuthSession {
  accessToken: string
  expiresIn: number
  tokenType: 'Bearer'
  user: CurrentUser
}

let refreshPromise: Promise<AuthSession> | null = null

export async function login(input: LoginInput): Promise<AuthSession> {
  const response = await authClient.post<AuthSession>(`${AUTH_PATH}/login`, input)
  return response.data
}

export function refreshSession(): Promise<AuthSession> {
  if (!refreshPromise) {
    refreshPromise = authClient
      .post<AuthSession>(`${AUTH_PATH}/refresh`)
      .then((response) => response.data)
      .finally(() => {
        refreshPromise = null
      })
  }
  return refreshPromise
}

export async function logout(): Promise<void> {
  await authClient.post(`${AUTH_PATH}/logout`)
}

configureAccessTokenRefresh(async () => {
  const session = await refreshSession()
  useUserStore.getState().setAuthenticated(session.user, session.accessToken)
  return session.accessToken
})
